/**
 * Build-time configs for local dev
 */

// Intentionally using process.env as this is a builtime config, for local dev
export const AUTH_TOKEN_OVERRIDE = process.env.REACT_APP_AUTH_TOKEN_OVERRIDE

export const STATIC_ASSETS_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://dev.epilot.cloud/elements-static'
    : 'https://go.epilot.cloud/elements-static'
